import { Routes } from '@angular/router';
import { AuthGuard, NonAuthGuard } from './guards';
import { BlankLayoutComponent, SideMenuLayoutComponent } from './layouts';

export const mobileRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/tabs/tabs.module').then((m) => m.TabsPageModule)
    },
    {
        path: 'product',
        loadChildren: () => import('./pages/product/product.module').then((m) => m.ProductModule)
    },

    {
        path: 'cart',
        loadChildren: () => import('./pages/cart/cart.module').then((m) => m.CartModule)
    },
    {
        path: 'auth',
        loadChildren: () => import('./pages/account/account.module').then((m) => m.AccountModule)
    },
    {
        path: 'global-search',
        loadChildren: () => import('./pages/search/search.module').then((m) => m.SearchModule)
    },
    {
        path: 'llp-delivery-address',
        loadChildren: () => import('./pages/llp-delivery-address/llp-delivery-address.module').then((m) => m.LlpDeliveryAddressPageModule)
    },
    {
        path: 'llp-order-info/:id',
        loadChildren: () => import('./pages/llp-order-info/llp-order-info.module').then((m) => m.LlpOrderInfoPageModule)
    },
    {
        path: 'sell-now',
        loadChildren: () => import('./pages/sell-now-form/sell-now-form.module').then((m) => m.SellNowFormPageModule)
    },

    {
        path: 'brands',
        loadChildren: () => import('./pages/brands/brands.module').then((m) => m.BrandsModule)
    },
    {
        path: 'sell-now/product/:id',
        loadChildren: () => import('./pages/sell-now-product-info/sell-now-product-info.module').then((m) => m.SellNowProductInfoPageModule)
    }
];

export const webRoutes: Routes = [
    {
        path: '',
        component: SideMenuLayoutComponent,
        children: [
            {
                path: 'sell-now',
                loadChildren: () =>
                    import('./pages/web/sell-now-product-steps/sell-now-product-steps.module').then((m) => m.SellNowProductStepsPageModule),
                canLoad: [AuthGuard]
            },
            {
                path: 'sell-now/products',
                loadChildren: () =>
                    import('./pages/web/sell-now-producs-list/sell-now-producs-list.module').then((m) => m.SellNowProducsListPageModule),
                canLoad: [AuthGuard]
            },
            {
                path: 'sell-now/product/:id',
                loadChildren: () =>
                    import('./pages/sell-now-product-info/sell-now-product-info.module').then((m) => m.SellNowProductInfoPageModule),
                canLoad: [AuthGuard]
            },
            {
                path: '',
                redirectTo: 'sell-now/products',
                pathMatch: 'full'
            }
        ]
    },
    {
        path: 'login',
        component: BlankLayoutComponent,
        loadChildren: () => import('./pages/web/login/login.module').then((m) => m.LoginPageModule),
        canLoad: [NonAuthGuard]
    },
    { path: '**', pathMatch: 'full', redirectTo: '' }
];
